"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconHighTechThematic = void 0;
var React = __importStar(require("react"));
var IconHighTechThematic = function (props) { return (React.createElement("svg", __assign({ width: 24, height: 24, viewBox: "0 0 24 24" }, props),
    React.createElement("path", { fill: "#464650", fillRule: "evenodd", d: "M16.5,20 C16.776,20 17,20.224 17,20.5 C17,20.776 16.776,21 16.5,21 L7.5,21 C7.224,21 7,20.776 7,20.5 C7,20.224 7.224,20 7.5,20 L11.5,20 L11.5,19.189 C11.5,18.913 11.724,18.689 12,18.689 C12.276,18.689 12.5,18.913 12.5,19.189 L12.5,20 L16.5,20 Z M21,17 L21,7 L20,7 L20,10.5 C20,11.327 19.327,12 18.5,12 L16.5,12 C15.673,12 15,11.327 15,10.5 L15,7 L3,7 L3,17 L21,17 Z M16,4.5 L16,10.5 C16,10.775 16.224,11 16.5,11 L18.5,11 C18.776,11 19,10.775 19,10.5 L19,4.5 C19,4.225 18.776,4 18.5,4 L16.5,4 C16.224,4 16,4.225 16,4.5 Z M20,6 L22,6 L22,18 L2,18 L2,6 L15,6 L15,4.5 C15,3.673 15.673,3 16.5,3 L18.5,3 C19.327,3 20,3.673 20,4.5 L20,6 Z M17.5,10 C17.224,10 17,9.776 17,9.5 C17,9.224 17.224,9 17.5,9 C17.776,9 18,9.224 18,9.5 C18,9.776 17.776,10 17.5,10 Z M17,6 L17,5 L18,5 L18,6 L17,6 Z M7.1465,11.1465 C7.3415,10.9515 7.6585,10.9515 7.8535,11.1465 C8.0485,11.3415 8.0485,11.6585 7.8535,11.8535 L4.8535,14.8535 C4.7555,14.9515 4.6275,15.0005 4.5005,15.0005 C4.3725,15.0005 4.2445,14.9515 4.1465,14.8535 C3.9515,14.6585 3.9515,14.3415 4.1465,14.1465 L7.1465,11.1465 Z M4.5,13 C4.372,13 4.244,12.951 4.146,12.854 C3.951,12.658 3.951,12.342 4.146,12.146 L6.146,10.146 C6.342,9.951 6.658,9.951 6.854,10.146 C7.049,10.342 7.049,10.658 6.854,10.854 L4.854,12.854 C4.756,12.951 4.628,13 4.5,13 Z" }))); };
exports.IconHighTechThematic = IconHighTechThematic;
exports.IconHighTechThematic.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconHighTechThematic;
